import { MessageProps } from 'message/index.props'
export const message: MessageProps = {
  i18n: {
    changeLanguage: 'English',
    toUrl: '/en/index.html',
  },
  meta: {
    site_name: '数寄屋風別館「佳水園」 - ウェスティン都ホテル京都',
    description:
      '数寄屋風別館「佳水園」が、2020年7月リニューアルオープンしました。元のデザインは承継しつつ、客室面積を拡大し、居住性の向上を図りました。さらに、各部屋に天然温泉を引き込み、上質な時間と空間をご提供いたします。',
    keywords:
      '佳水園, ラグジュアリー, 温泉, ウェスティン, 都ホテル, 京都, 宿泊, 旅館',
  },
  global: {
    language: {
      select: 'Language',
      japanese: '日本語',
      english: 'English',
    },
    reservation: 'ご予約はこちら',
    reservation_button: {
      url:
        'https://reservation.miyakohotels.ne.jp/#/booking/result?code=31070c31fc826f7425715be5fe32931d&room_type_codes=36,37,38',
    },
    detail: '詳細を見る',
    topic_path: {
      top: 'TOP',
      overview: '外観',
      rooms: '部屋タイプ',
      service: '料理・サービス',
    },
    westinkyoto: {
      kasuien: '佳水園（ウェスティン都ホテル京都）',
      address: '〒605-0052 京都市東山区粟田口華頂町1(三条けあげ)',
      tel: 'TEL: 075-771-7111',
    },
    inquiry: 'お問い合わせへ',
    inquiry_button: {
      url:
        'https://reg18.smp.ne.jp/regist/is?SMPFORM=mekj-pdqgs-1fb655c8340370a1784cd1647f125520&hotel=westinkyoto&type=stay',
    },
    copyright:
      'Copyright © 2020 Kintetsu Miyako Hotels International, Inc. All Rights reserved.',
    to_top: 'ウェスティン都ホテル京都TOPへ',
    to_top_button: {
      url: 'https://www.miyakohotels.ne.jp/westinkyoto/index.html',
    },
  },
  top: {
    page_title: '数寄屋風別館「佳水園」 - ウェスティン都ホテル京都',
    catchcopy: 'ゆったりと「和」を味わう佳水園',
    renewal_open_day: {
      title: '2020年7月リニューアルオープン',
      text:
        '村野藤吾氏の設計による、華頂山に続く高低差のある地形を活かした<br class="mb-hidden">美しくリズミカルな外観や、渡り廊下・ロビーなどの内部デザインは承継。<br>2 室を 1 室にするなど客室面積を広げることで、ゆとりと心地良さの向上を図りました。<br>各部屋のお風呂には天然温泉を引き込み、ぜいたくなくつろぎの時間と空間をご提供いたします。',
    },
    kasuien: '佳水園',
    contents1: {
      num: '1',
      title: '村野藤吾が手がけたくつろぎの時間',
      text:
        '1959年に建設された数寄屋風建築の「佳水園」。当時の趣はそのままに、新たに生まれ変わった空間でくつろぎの時間をお過ごしください。',
    },
    contents2: {
      num: '2',
      title: '非日常へのアプローチ',
      text:
        '重厚な檜皮葺の門をくぐると日常の喧騒を忘れさせる安らぎの空間。瓢箪が印象的な「白砂の中庭」や、<br class="mb-hidden">自然の岩盤を利用した「佳水園庭園」が鑑賞でき、訪れる者の心を惹きつけます。',
    },
    contents3: {
      num: '3',
      title: 'ゆとりと心地良さのしつらえ',
      text:
        '全室に天然温泉を引き込み、高野槇や檜を使用した浴槽を設置。さわやかな木の香りがリラックスムードを高め、<br class="mb-hidden">旅の疲れをじっくりと癒してくれます。',
    },
    contents4: {
      num: '4',
      title: 'ぜいたくなトキの体験',
      text:
        '佳水園専属の「女将」がお客さまのお食事の手配や観光案内など、より良い京都の滞在になるようお手伝いします。<br>1日1組限定で、季節の食材や京都の食材を使用したお客さまだけの特別会席をお楽しみいただけるプランもご用意。',
    },
    hospitality: {
      title: '「佳水園」が織りなすあしらい',
      text:
        '佳水園ではこだわりのアメニティなどをはじめ、細部までおもてなしの心を忍ばせています。心身ともにリラックスしていただける「佳水園」を是非ご堪能ください。',
    },
  },
  overview: {
    page_title: '外観',
    title: '自然との交歓',
    text:
      '高低差のある地形を活かした棟配置や銅板葺の屋根の連なり、幾重にも組み入った庇などが<br class="mb-hidden pc-hidden">空間に独特の<br class="mb-tb-hidden">リズムを与え、訪れる者の心を惹きつけます。',
    contents1: {
      title: '数寄屋風別館「佳水園」',
      text:
        '歴史を感じさせる重厚な檜皮葺の門をくぐると、そこに広がるのは日常の喧騒を忘れさせる安らぎの空間。<br>日本モダニズム建築を代表する村野藤吾氏の息づかいを感じられます。',
    },
    contents2: {
      title: '自然の岩盤を使用した「佳水園庭園」',
      text:
        '作庭は、平安神宮などの造園で知られる7代目小川治兵衛氏の長男、白楊氏。巨大な天然岩盤を活用して造られた独特なデザインで、中央には滝が静かに流れ落ちます。<br>【京都市文化財(名勝)平成6年4月1日登録】',
    },
    contents3: {
      title: '村野藤吾による「白砂の中庭」',
      text:
        '昭和34年（1959年）、佳水園を設計した村野藤吾氏は、醍醐寺三宝院の庭を模して白砂敷きの中庭をデザインしました。緑で表現された瓢箪と杯は、佳水園庭園の岩盤から流れる滝の水をお酒に見立てています。',
    },
    contents4: {
      title: '夜の佳水園',
      text:
        '幻想的な雰囲気の夜の佳水園。昼間とはまた違った姿を見せてくれます。',
    },
  },
  rooms: {
    page_title: '部屋タイプ',
    title: '上質で快適な滞在',
    text:
      '一部屋ごとにタイプが異なる12の客室をご用意。52～101㎡のゆとりある空間で、全てのバスルームで華頂山から湧出した天然温泉をお楽しみいただけるなど、どの部屋においても上質な滞在をお約束します。',
    room_type: '部屋タイプ',
    room1_name: '100～101㎡',
    room2_name: '70～84㎡',
    room3_name: '52～68㎡',
    room1: {
      title: '100～101㎡',
      text:
        '約100㎡の贅沢な間取り。ゆとりある空間には繊細な意匠が施され、風雅でエレガントな時間を演出します。<br>世間の喧騒から離れ、非日常的な空間で至福の時間をお過ごしください。',
    },
    room2: {
      title: '70～84㎡',
      text:
        'ゆとりある空間は、自宅で過ごすかのようなリラックスした滞在をかなえます。<br>全室に書斎を設けており、落ち着きのある静かな空間で読書など、安らぎの時間をお楽しみいただけます。',
    },
    room3: {
      title: '52～68㎡',
      text:
        'モダンな洋風、落ち着きのある和風など間取りの異なるお部屋をご用意。<br>お部屋により、豊かな自然が目前に広がったり、京都の街並みが一望できたりと窓から楽しめる景色もさまざま。',
    },
    spec_name: {
      room_size: '広さ',
      capacity: '定員',
      bed_type: 'ベッドタイプ',
      bed_size: 'ベッドサイズ',
      facilities: '設備',
      amenity: 'アメニティ',
    },
    spec_room1: {
      room_size: '100～101㎡',
      capacity: '2名',
      bed_type: 'ツイン 2室',
      bed_size: 'シングルベッド：幅110～120cm、長さ200cm',
      facilities:
        'テレビ、電話、時計、ミニバー（有料）、電気ポット、コーヒーマシーン、金庫、Wi-Fi（無料）、ドライヤー、ヘルスメーター、アイロン、アイロン台、加湿器付空気清浄機、湯呑み、グラス、ワイングラス、衣類用消臭スプレー、洋服ブラシ、靴べら、ハンドタオル、フェイスタオル、バスタオル、バスマット、浴衣、パジャマ、バスローブ',
      amenity:
        'ソープ、シャンプー、コンディショナー、ボディーウォッシュ、ボディーローション、ボディータオル、歯ブラシ、マウスウォッシュ、カミソリ、バニティセット(コットン、綿棒、爪やすり)、コーム、ティッシュボックス、スリッパ、エスプレッソカプセル、ティーバック（日本茶、紅茶）、無料ミネラルウォーター',
    },
    spec_room2: {
      room_size: '70～84㎡',
      capacity: '２名',
      bed_type: 'ツイン 1室、キング 5室',
      bed_size:
        'キングベッド：幅200cm、長さ200cm<br>シングルベッド：幅110～120cm、長さ200cm',
      facilities:
        'テレビ、電話、時計、ミニバー（有料）、電気ポット、コーヒーマシーン、金庫、Wi-Fi（無料）、ドライヤー、ヘルスメーター、アイロン、アイロン台、加湿器付空気清浄機、湯呑み、グラス、ワイングラス、衣類用消臭スプレー、洋服ブラシ、靴べら、ハンドタオル、フェイスタオル、バスタオル、バスマット、浴衣、パジャマ、バスローブ',
      amenity:
        'ソープ、シャンプー、コンディショナー、ボディーウォッシュ、ボディーローション、ボディータオル、歯ブラシ、マウスウォッシュ、カミソリ、バニティセット(コットン、綿棒、爪やすり)、コーム、ティッシュボックス、スリッパ、エスプレッソカプセル、ティーバック（日本茶、紅茶）、無料ミネラルウォーター',
    },
    spec_room3: {
      room_size: '52～68㎡',
      capacity: '2名',
      bed_type: 'ツイン 2室　キング 2室',
      bed_size:
        'キングベッド：幅200cm、長さ200cm<br>シングルベッド：幅110～120cm、長さ200cm',
      facilities:
        'テレビ、電話、時計、ミニバー（有料）、電気ポット、コーヒーマシーン、金庫、Wi-Fi（無料）、ドライヤー、ヘルスメーター、アイロン、アイロン台、加湿器付空気清浄機、湯呑み、グラス、ワイングラス、衣類用消臭スプレー、洋服ブラシ、靴べら、ハンドタオル、フェイスタオル、バスタオル、バスマット、浴衣、パジャマ、バスローブ',
      amenity:
        'ソープ、シャンプー、コンディショナー、ボディーウォッシュ、ボディーローション、ボディータオル、歯ブラシ、マウスウォッシュ、カミソリ、バニティセット(コットン、綿棒、爪やすり)、コーム、ティッシュボックス、スリッパ、エスプレッソカプセル、ティーバック（日本茶、紅茶）、無料ミネラルウォーター',
    },
  },
  service: {
    page_title: '料理・サービス',
    title: '佳水園のおもてなし',
    text:
      'お客さまの特別なひとときのために、細部にまでおもてなしの心を忍ばせています。<br>ここでしか味わえない特別会席や、女将のおもてなし、心身ともにリラックスしていただけるトリートメントなど<br class="mb-hidden">上質な滞在をお楽しみください。',
    dining: {
      title: '季節の料理に舌鼓を',
      text:
        '1日1組限定の「佳水園プラン」では、お部屋で夕食・朝食を召し上がっていただけます。夕食では、お客さま一人ひとりにお好みをお伺いし、お客さまだけの特別メニューをご用意します。',
    },
    particular: 'こだわりのひととき',
    contents1: {
      title: '客室での特別会席料理',
      text:
        '佳水園プランは、事前にお好みをお伺いし、京都の旬の食材をふんだんに用いて作る会席です。目の前で握るお寿司など、お客さまだけの特別メニューをお楽しみいただけます。',
    },
    contents2: {
      title: '女将のおもてなし',
      text:
        '佳水園専属の「女将」を配置し、お客さまの食事の手配や、観光案内など、より良い京都の滞在になるようお手伝いします。季節のお花や呈茶をはじめ女将の心のこもったおもてなしでお客さまをお出迎えします。',
    },
    contents3: {
      title: '佳水園の世界に浸るライブラリー',
      text:
        '「佳水園」の特徴である雁行する建築をモチーフにした本棚には、村野藤吾氏や古都京都、日本文化に関する書籍をご用意。ゆったりとしたローソファで、お好きなお飲み物とともに、くつろぎの時間をお過ごしください。',
    },
    contents4: {
      title: '佳水園インルームスパ',
      text:
        'お部屋で施術が受けられ『佳水園×エステティック×鍼灸』のコラボレーションメニューは、女性だけではなく、男性にもご利用いただけるトリートメントです。心と身体の再生と調和を目的とした新しい寛ぎの形を、京の薫りとともにご体感ください。',
    },
  },
}
